import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const fillRateByCompanyResponse = z.array(
  z.object({
    company_name: z.string(),
    shift_date: z.string(),
    workers_needed_final: z.number().nullable().optional(),
    workers_needed_final_forecast: z.number().nullable().optional(),
    fill_rate: z.number().nullable().optional(),
  })
)

export type FillRateByCompany = z.infer<typeof fillRateByCompanyResponse>

export async function getFillRateByCompany(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_by_location', data, { signal })
    .then((response) => response.data)
    .then(fillRateByCompanyResponse.parse)
}

export async function getFillRateByCompanyCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/fill_rate_by_location/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
